import React, { Component } from 'react';

export class AboutCompany extends Component {
	displayName = AboutCompany.name

	render() {
		return (
			<div>
				<h1>О компании</h1>
				<div>
					<b>«Акварель Кухни»</b> – это не просто фабричное производство кухонь, это место, где рождаются кухни вашей мечты.
					 Наше современное оборудование и команда высококвалифицированных специалистов создают пространство, где важна каждая деталь.
						Мы работаем с ответственностью, контролируем качество на каждом этапе и вкладываем душу в каждую кухню.
					<br /><br />
					<p>
						Мы понимаем, что в создании идеального кухонного пространства важен каждый элемент.<br />
						Используем только качественные комплектующие и фурнитуру от надежных зарубежных производителей.<br />
						Постоянно внедряем новые технологии и разработки, чтобы соответствовать ожиданиям современных покупателей.<br />
						Наши дизайнеры всегда готовы предложить свежие и оригинальные решения для вашего дома.<br />
					</p>
					<br /><b>НАШИ ПРИНЦИПЫ:</b><br /><br />
					<p>
						<ul>
							<li>Предлагаем стильный дизайн и широкий выбор материалов для кухонной мебели.</li>
							<li>Гарантируем высокое качество благодаря новым технологиям, современному оборудованию и строгому контролю на всех этапах производства.</li>
							<li>Обеспечиваем надежность упаковки, чтобы ваша кухня пришла в идеальном состоянии.</li>
							<li>Ставим интересы потребителей на первое место, предоставляя максимум преимуществ и выгод.</li>
						</ul>
					</p>

					<br /><b>ВЫБРАВ НАС, ВЫ ПОЛУЧАЕТЕ:</b><br /><br />
					<p>
						<ul>
							<li>Эксклюзивный дизайн кухни от опытных профессионалов.</li>
							<li>Бесплатный и качественный замер на месте нашими специалистами(в пределах Ярославля).</li>
							<li>Бесплатную доставку в пределах Ярославля.</li>
							<li>Обслуживание кухонь в течение гарантийного срока силами наших специалистов.</li>
						</ul>
					</p>
					С <b>«Акварель Кухни»</b> вы получаете не просто кухню, а пространство, созданное с любовью и вниманием к каждой детали.<br />
				</div>
			</div>
		);
	}
}